import { Record } from "immutable";

const WidgetListItemRecord = new Record({
  id: undefined,
  name: "",
  code: "",
  stat: {
    clicks: 0,
    shows: 0,
    ctr: 0,
    vctr: 0,
    revenue: 0,
    rpm: 0,
    vrpm: 0,
    vshows_percent: 0,
  }
});

export default class WidgetListItem extends WidgetListItemRecord {
  getStatus() {
    return this.stat.shows ? "Транслируется" : "Нет показов";
  }
}
